import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config';
import { Groups } from '../../model/groups';
import { Observable } from 'rxjs';
import { StorageService } from '../managers/storage.service';

@Injectable({
  providedIn: 'root'
})
export class GroupsService extends Config {

  constructor(private httpClient: HttpClient,
    private storageService: StorageService) {
    super();
  }

  public createGroup(reqGroup: any): Observable<any> {
    var url;

    url = "groups_create";

    return this.httpClient.post(this.BASE_URL + url, reqGroup, this.storageService.getHeaders());
  }

  public uploadPID(reqGroup: any): Observable<any> {
    var url;

    url = "group_upload_pid";

    return this.httpClient.post(this.BASE_URL + url, reqGroup, this.storageService.getHeaders());
  }

  public updateGroup(reqGroup: any): Observable<any> {
    var url;

    url = "groups_update";

    return this.httpClient.post(this.BASE_URL + url, reqGroup, this.storageService.getHeaders());
  }

  public getGroups(maxItemPerPage: number, keyword: string, page: number): Observable<any> {
    var url;

    url = "groups_get";

    if (maxItemPerPage != null) {
      url += ("?maxItemPerPage=" + maxItemPerPage) +
        (keyword != null ? "&keyword=" + keyword : "");
    }

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }

  public getGroup(id: number): Observable<any> {
    var url;

    url = "groups_get_by_id";
    url += ("?id=" + id);

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }

  public getCount() {
    let url;

    url = this.BASE_URL + "count_groups";

    return this.httpClient.get(url, this.storageService.getHeaders());
  }


 // http://localhost:8090/joytogive/backend/public/api/groups_custom_data?group_id=2

  
  public getCustomGroupData(group_id:any){
    var url;

    url = "groups_custom_data";
    url += ("?group_id=" + group_id);

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }

  public getCustomGroupHeader(group_id:any){
    var url;

    url = "groups_custom_header";
    url += ("?group_id=" + group_id);

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }

}



